import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const sidebarSelector = state => state.app.sidebar;

const isSidebarMinimized = createSelector(
  sidebarSelector,
  sidebar => sidebar.minimized
);

export default isSidebarMinimized;



// WEBPACK FOOTER //
// ./src/_selectors/appSelectors/isSidebarMinimized.js